import api from "../axiosConfig";

 
 
 
 export const getLabAppointments = async (doctor_id,selectedDate,hospital_id) => {
    try {
      const response = await api.get('/appointment/all-appointment',
      {
        params: {
          appointment_date: selectedDate,
        },
      });
  
      const resData = response?.data;
      console.log('Response data:', resData);
  
      if (resData?.success_type === 'success'|| resData?.message_type === 'success') {
        return { success: true, data: resData?.data };
      } else {
        return { success: false, error: resData.message };
      }
    } catch (err) {
      throw new Error(err.response?.data?.message || 'Error fetching Appointments');
    }
  };

  export const getAppointmentReports = async (patient_id, limit=0) => {
    try {
      const response = await api.get('/appointment-reports/all',
      {
        params: {
          patient_id: patient_id,
          limit:limit
        },
      });
  
      const resData = response?.data;
      // console.log('Response data:', resData);
  
      if (resData?.success_type === 'success'|| resData?.message_type === 'success') {
        return { success: true, data: resData?.data };
      } else {
        return { success: false, error: resData.message };
      }
    } catch (err) {
      throw new Error(err.response?.data?.message || 'Error fetching Appointments');
    }
  };

  export const createReport = async (data) => {
    try {
      const response = await api.post('/appointment-reports/create',data);
  
      const resData = response?.data;
      console.log('Response data:', resData);
  
      if (resData?.success_type === 'success'|| resData?.message_type === 'success') {
        return { success: true, data: resData?.data };
      } else {
        return { success: false, error: resData.message };
      }
    } catch (err) {
      throw new Error(err.response?.data?.message || 'Error fetching Appointments');
    }
  };